const TokenKey = ['token'];

// 白名单接口，调用不带 token 的接口时候需要传
export const WHITE_REQUEST_LIST = [
    '/ntp/notify-info/queryPage',
    '/ntp/baseUserInfo/mobile/login',
    '/ntp/baseUserInfo/sendMessage',
    '/ntp/baseUserInfo/resetNotLoginPassWord',
    '/ntp/baseAnhzInfo/skyEyeCheck',
    '/ntp/lcFile/ntpUploadWithOcr',
    '/ntp/baseAnhzInfo/register',
    '/ntp/tms-evaluation-statistic/queryPage',
    '/ntp/waybill-order/homePage/queryTotal',
    '/ntp/baseAnhzInfo/getRegisterNum',
    '/ntp/baseUserInfo/getPublicKey',
    '/ntp/baseUserInfo/mip/login',
    '/ntp/apiAuth/getRequestUuid'
];

export function getToken() {
    return sessionStorage.getItem(TokenKey[0]);
}

export function setToken(token) {
    sessionStorage.setItem(TokenKey[0], token);
}

export function removeToken(token) {
    sessionStorage.removeItem(TokenKey[0]);
}
// 从缓存中获取当前账号的货主列表信息
export function getCargoOwnerInfo() {
    return sessionStorage.getItem('cargoOwnerInfo');
}
// 缓存当前账号的货主列表信息
export function setCargoOwnerInfo(data) {
    sessionStorage.setItem('cargoOwnerInfo', data);
}

export function removeCargoOwnerInfo() {
    sessionStorage.removeItem('cargoOwnerInfo');
}
// 缓存当前货主菜单
export function setInitResources(data) {
    sessionStorage.setItem('initResources', JSON.stringify(data));
}
// 缓存当前货主菜单
export function getInitResources() {
    return sessionStorage.getItem('initResources');
}
